import depositIcon from '@assets/images/deposite.svg'
import investmentIcon from '@assets/images/investment.svg'
import rentalIncomeIcon from '@assets/images/rental_income.svg'
import withdrawalIcon from '@assets/images/withdrawal.svg'
import type { PiIconName } from '@uiKit/elements/PiIcon.vue'
import type { TransactionStatus, TransactionType } from '../types/transactionTypes'

export interface TypeTheme {
  gradientFrom: string
  iconBg: string
  iconBorder: string
  iconColor: string
  amountColor: string
  icon: PiIconName
  imageSrc?: string
}

export interface StatusConfig {
  label: string
  bg: string
  color: string
  icon: PiIconName
}

// TODO(design): token_received uses a bespoke lime palette (#f5fee7 /
// #dcfce7 / #a3e635 / #58a40c) that has no semantic match in slicealPreset.
// Either promote to `--p-sliceal-token-*` or remap to success.
const TOKEN_BG_LIGHT = '#f5fee7'
const TOKEN_BG_MID = '#dcfce7'
const TOKEN_BORDER = '#a3e635'
const TOKEN_TEXT = '#58a40c'

export const TRANSACTION_TYPE_THEME: Record<TransactionType, TypeTheme> = {
  deposit: {
    gradientFrom: 'var(--p-success-50)',
    iconBg: 'var(--p-success-100)',
    iconBorder: 'var(--p-success-300)',
    iconColor: 'var(--p-success-700)',
    amountColor: 'var(--p-success-700)',
    icon: 'arrow-circle-down',
    imageSrc: depositIcon,
  },
  investment: {
    gradientFrom: 'var(--p-primary-50)',
    iconBg: 'var(--p-primary-100)',
    iconBorder: 'var(--p-primary-300)',
    iconColor: 'var(--p-primary-600)',
    amountColor: 'var(--p-primary-600)',
    icon: 'wallet',
    imageSrc: investmentIcon,
  },
  rental_income: {
    gradientFrom: 'var(--p-info-50)',
    iconBg: 'var(--p-info-100)',
    iconBorder: 'var(--p-info-300)',
    iconColor: 'var(--p-info-500)',
    amountColor: 'var(--p-info-500)',
    icon: 'home',
    imageSrc: rentalIncomeIcon,
  },
  withdrawal: {
    gradientFrom: 'var(--p-danger-50)',
    iconBg: 'var(--p-danger-200)',
    iconBorder: 'var(--p-danger-300)',
    iconColor: 'var(--p-danger-500)',
    amountColor: 'var(--p-danger-500)',
    icon: 'arrow-circle-up',
    imageSrc: withdrawalIcon,
  },
  refund: {
    gradientFrom: 'var(--p-success-50)',
    iconBg: 'var(--p-success-100)',
    iconBorder: 'var(--p-success-300)',
    iconColor: 'var(--p-success-700)',
    amountColor: 'var(--p-success-700)',
    icon: 'arrow-circle-down',
  },
  token_received: {
    gradientFrom: TOKEN_BG_LIGHT,
    iconBg: TOKEN_BG_MID,
    iconBorder: TOKEN_BORDER,
    iconColor: TOKEN_TEXT,
    amountColor: TOKEN_TEXT,
    icon: 'tag',
  },
  rental: {
    gradientFrom: 'var(--p-info-50)',
    iconBg: 'var(--p-info-100)',
    iconBorder: 'var(--p-info-300)',
    iconColor: 'var(--p-info-500)',
    amountColor: 'var(--p-info-500)',
    icon: 'home',
  },
}

export const TRANSACTION_STATUS_CONFIG: Record<TransactionStatus, StatusConfig> = {
  completed: {
    label: 'Completed',
    bg: 'var(--p-success-100)',
    color: 'var(--p-success-700)',
    icon: 'check-circle',
  },
  pending: {
    label: 'Pending',
    bg: 'var(--p-warning-100)',
    color: 'var(--p-warning-700)',
    icon: 'clock',
  },
  processing: {
    label: 'Processing',
    bg: 'var(--p-info-100)',
    color: 'var(--p-info-500)',
    icon: 'refresh',
  },
  failed: {
    label: 'Failed',
    bg: 'var(--p-danger-200)',
    color: 'var(--p-danger-500)',
    icon: 'times',
  },
  reversed: {
    label: 'Reversed',
    bg: 'var(--p-surface-100)',
    color: 'var(--p-text-muted-color)',
    icon: 'refresh',
  },
}
